import React from "react";

const stats = [
  { number: "6+", label: "Years Experience" },
  { number: "3", label: "Live Apps" },
  { number: "2000+", label: "Users" },
  { number: "MSc", label: "Data Science" },
];

const Hero = () => {
  return (
    <section className="hero" id="top">
      <div className="hero-inner">
        <div className="badge-pill reveal">
          <span className="badge-dot" />
          Available for full-time roles
        </div>

        <h1 className="hero-title reveal">
          I build <span className="gradient-text">production apps</span>
          <br />
          people actually use.
        </h1>

        <p className="hero-subtitle reveal">
          Full-stack & mobile developer shipping with Flutter, React, and
          Node.js. 6+ years turning ideas into apps with real users and real
          transactions.
        </p>

        <div className="hero-actions reveal">
          <a href="#projects" className="btn btn-primary">
            View My Work
          </a>
          <a href="#contact" className="btn btn-secondary">
            Get In Touch
          </a>
        </div>

        <div className="hero-stats reveal">
          {stats.map((stat) => (
            <div className="hero-stat" key={stat.label}>
              <div className="number">{stat.number}</div>
              <div className="label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
